'use strict';

var App = undefined;
var AppState = undefined;
var Consts = undefined;

var DeviceDropDownList = {};

var templateList = require('utils/templates/device_dropdown_list');
var templateContent = require('utils/templates/device_dropdown_content');

var ddls = {};
var requests = {};
var pageSize = 15;

var lastID = 0;

module.exports = {
    create: function (html, selected, styleClass) {
        // prevent unwanted changes to the dropdown button style
        if (typeof styleClass !== 'string') {
            styleClass = undefined;
        }
        // create data context for the drop down list
        var myEl = undefined;
        lastID++;
        var dataCtx = {
            id: 'devddl_' + lastID,
            $el: function () {
                if (myEl) return myEl;
                var el = $('#' + this.id);
                if (el.length > 0) myEl = el;
                return el;
            },
            selected: selected ? parseInt(selected) : undefined,
            initialCount: undefined,
            count: undefined,
            from: 0,
            filter: undefined,
        };
        ddls[dataCtx.id] = dataCtx;

        var newContent = templateList({
            id: dataCtx.id,
            styleClass: styleClass,
        });

        var el = $(document.createElement('div'));
        el.html(html);
        // make original drop down list invisible
        var $select = el.find('select');
        var selectID = $select.attr('id');
        if (!selectID) {
            selectID = 'select_' + dataCtx.id;
            $select.attr('id', selectID);
        }
        dataCtx.selectID = selectID;
        $select.css('opacity', 0.0);
        $select.css('width', '0px');
        $select.css('height', '0px');
        $select.css('position', 'absolute');
        // add dummy option with selected value
        var $option = $(document.createElement('option'));
        $option.attr('value', selected);
        $option.text('dummy');
        $select.append($option);

        // create dummy SELECT for catching keyboard events
        dataCtx.keybSelectID = 'select_keyb_ddl_device_' + dataCtx.id;
        var $select2 = $(document.createElement('select'));
        $select2.attr('id', dataCtx.keybSelectID);
        el.append($select2);
        $select2.css('opacity', 0.0);
        $select2.css('position', 'absolute');
        $select2.css('width', '0px');
        $select2.css('height', '0px');

        // read the first page
        var selectCode = el.html();
        return selectCode + newContent;
    },

    initialize: function (item, options) {
        this.styleClass = options.styleClass;
        var self = this;
        var dataCtx = ddls[item.id];
        if (dataCtx.initialized) return;
        dataCtx.initialized = true;
        dataCtx.options = options || {};
        dataCtx.filter = { name: '' };

        // late initialize of units
        App = App || require('app');
        AppState = AppState || require('app_state');
        Consts = Consts || require('consts');

        dataCtx.$select = $('select#' + dataCtx.selectID);
        dataCtx.$keybSelect = $('select#' + dataCtx.keybSelectID);

        // load content
        dataCtx.initializing = true;
        this.loadContent(dataCtx);

        // init events
        var lastFilterVal = '';
        var $filter = dataCtx.$el().find('.js-filter');
        $filter.on('keyup', function () {
            dataCtx.filter.name = $filter.val();
            if (dataCtx.filter.name != lastFilterVal) {
                dataCtx.from = 0;
                lastFilterVal = dataCtx.filter.name;
            }
            self.loadContent(dataCtx);
        });

        dataCtx
            .$el()
            .find('button.dropdown-toggle')
            .on('click', function () {
                setTimeout(function () {
                    dataCtx.$keybSelect.focus();
                }, 10);
            });

        dataCtx.$keybSelect.on('change', function () {
            var value = dataCtx.$keybSelect.val();
            self.track(dataCtx, value);
        });
        dataCtx.$keybSelect.on('keydown', function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                var value = dataCtx.$keybSelect.val();
                var $a = dataCtx
                    .$el()
                    .find('li a[data-device-id="' + parseInt(value) + '"]')
                    .first();
                $a.trigger('click');
                return;
            }

            var allowedKeys = [35, 36, 38, 40];

            if (allowedKeys.indexOf(e.keyCode) == -1) {
                e.preventDefault();
                e.stopPropagation();
            }
        });

        dataCtx.$select.on('change', function () {
            self.showContent(dataCtx);
        });
    },

    track: function (dataCtx, value) {
        dataCtx.$el().find('li a').removeClass('highlight');
        dataCtx
            .$el()
            .find('li a[data-device-id="' + parseInt(value) + '"]')
            .addClass('highlight');
    },

    loadContent: function (dataCtx) {
        var self = this;
        var from = dataCtx.from || 0;

        // initialize filter - retake props from options
        var filterFct =
            (dataCtx.options || {}).filter ||
            function () {
                return {};
            };
        _.each(filterFct(), function (value, key) {
            dataCtx.filter[key] = dataCtx.filter[key] || value;
        });

        var key = from + ',' + (dataCtx.count || 20) + ',' + JSON.stringify(dataCtx.filter);
        dataCtx.lastRequestKey = key;
        if (!requests[key]) {
            requests[key] = App.request('device:name:list', dataCtx.filter, from, pageSize);
            // add auto cleanup
            setTimeout(function () {
                if (requests[key]) delete requests[key];
            }, 30000);
        }

        $.when(requests[key]).done(function (result) {
            // if it's not the last request, no need to do anything, we wait
            if (key != dataCtx.lastRequestKey) return;
            if (dataCtx.initialCount === undefined) {
                dataCtx.initialCount = result.count;
            }
            if (dataCtx.options.filterResult && typeof dataCtx.options.filterResult === 'function') {
                result.items = dataCtx.options.filterResult(result.items);
            }

            dataCtx.count = result.count;
            if (dataCtx.options.selectFirst && result.items && result.items.length > 0) {
                dataCtx.selected = dataCtx.selected || parseInt(result.items[0].id);
                // make sure that the option is there
                dataCtx.$select.find('option').attr('value', dataCtx.selected);
                // select it actually
                dataCtx.$select.val(dataCtx.selected);
            }

            // check the currently selected device
            self.checkSelectedDevice(dataCtx, function () {
                self.showContent(dataCtx, result.items);
            });

            if (dataCtx.count == 0 && dataCtx.options.hideIfEmpty != '') {
                $(dataCtx.options.hideIfEmpty).hide();
            }

            // check empty result only once
            dataCtx.options.hideIfEmpty = '';
            if (dataCtx.initializing) {
                dataCtx.initializing = false;
                if (dataCtx.options.onInitialized) {
                    dataCtx.options.onInitialized();
                }
            }
        });
    },

    checkSelectedDevice: function (dataCtx, fctDone) {
        if (!dataCtx.selected || AppState.isDeviceRegistered(dataCtx.selected)) {
            fctDone();
            return;
        }

        var req = App.request('device:names', [dataCtx.selected]);
        $.when(req).done(function () {
            fctDone();
        });
    },

    syncSelect: function (dataCtx, items) {
        var $select = dataCtx.$select;
        var selected = dataCtx.$select.val();
        var selected = parseInt(selected);
        var selectedFound = false;

        $select.html('');

        var allItems = [items];

        if (_.where(items, { id: selected }).length == 0) {
            var deviceInfo = AppState.getDeviceInfo(selected);
            allItems.push({ id: selected, name: deviceInfo.name || '?' });
        }
        allItems = _.compact(_.flatten(allItems));

        _.each(allItems, function (item) {
            var $elOption = $(document.createElement('option'));
            $elOption.attr('value', item.id);
            $elOption.text(item.name);
            $select.append($elOption);
            selectedFound = selectedFound || item.id == selected;
        });

        // select an old value in the select
        $select.val(selected);
        this.updateText(dataCtx);

        // sync with the keyb select
        dataCtx.$keybSelect.html($select.html());
    },

    updateText: function (dataCtx) {
        var oldText = '';
        if (dataCtx.selected && AppState) {
            oldText = this.getDeviceText(undefined, dataCtx.selected);
        }

        dataCtx
            .$el()
            .find('.text')
            .html(oldText || '--');
    },

    getDeviceText: function (name, id) {
        var deviceInfo = AppState.getDeviceInfo(id);
        var categoryData = Consts.DeviceCategory[deviceInfo.category] || {};
        var lock = AppState.showLockIcon(id) ? ' <i class="fa fa-lock"></i> ' : '';

        return (
            (categoryData.icon ? '<i class="' + categoryData.icon + '"></i> ' : '') +
            Handlebars.escapeExpression(name || deviceInfo.name || '?') +
            lock
        );
    },

    showContent: function (dataCtx, items) {
        items = items !== undefined ? items : dataCtx.lastItems;
        dataCtx.lastItems = items;
        // update the content
        var self = this;
        var oldText;
        var oldIcon;

        if (dataCtx.selected && AppState) {
            var deviceInfo = AppState.getDeviceInfo(dataCtx.selected);
            var categoryData = Consts.DeviceCategory[deviceInfo.category] || {};
            oldText = deviceInfo.name || '?';
            oldIcon = categoryData.icon;
        }

        var showOldValue =
            _.filter(items, function (item) {
                return item.id == dataCtx.selected;
            }).length == 0;

        var content = templateContent({
            from: dataCtx.from + 1,
            till: Math.min(dataCtx.from + pageSize, dataCtx.count),
            items: _.map(items, function (item) {
                var categoryData = Consts.DeviceCategory[item.category] || {};
                return {
                    id: item.id,
                    name: item.name,
                    icon: categoryData.icon,
                    link: item.link,
                    locked: item.locked,
                };
            }),
            count: dataCtx.initialCount,
            showPageination: dataCtx.count > pageSize,
            canPrev: dataCtx.from != 0,
            canNext: dataCtx.from < dataCtx.count - 1 * pageSize,
            oldValue: showOldValue ? dataCtx.selected : undefined,
            oldText: oldText,
            oldIcon: oldIcon,
        });
        dataCtx.$el().find('.devicepicker-content').html(content);
        this.syncSelect(dataCtx, items);
        if (dataCtx.initialCount <= pageSize) {
            $('#' + dataCtx.id + ' .js-dropdown-filter-box').hide();
        }

        // attach events
        dataCtx
            .$el()
            .find('.js-prev')
            .on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                dataCtx.from = Math.max(dataCtx.from - pageSize, 0);
                self.loadContent(dataCtx);
            });
        dataCtx
            .$el()
            .find('.js-next')
            .on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                dataCtx.from = Math.min(dataCtx.from + pageSize, dataCtx.count - 1);
                self.loadContent(dataCtx);
            });

        if (dataCtx.options.onClick) {
            dataCtx.$el().find('li a').on('click', dataCtx.options.onClick);
        } else {
            dataCtx
                .$el()
                .find('li a')
                .on('click', function (e) {
                    e.preventDefault();
                    var deviceID = parseInt($(e.currentTarget).attr('data-device-id'));
                    // mark as selected
                    dataCtx.selected = deviceID;
                    self.updateSelected(dataCtx);
                    self.updateText(dataCtx);
                });
        }

        dataCtx
            .$el()
            .find('li a')
            .on('mouseover', function (e) {
                var deviceID = parseInt($(e.currentTarget).attr('data-device-id'));
                dataCtx.$keybSelect.val(deviceID);
                dataCtx.$keybSelect.focus();
            });
    },

    updateSelected: function (dataCtx) {
        var $select = dataCtx.$select;
        if ($select.val() != dataCtx.selected) {
            $select.val(dataCtx.selected);
            $select.trigger('change');
        }
    },
};
